// Here will be all the constants and those variables who will be reused in our project.

// export const API_URL = "https://forkify-api.jonas.io/api/v2/recipes/";
export const API_URL = "https://forkify-api.herokuapp.com/api/v2/recipes/";

export const TIMEOUT_SECONDS = 15;

export const RES_PER_PAGE = 10;

export const KEY = "63aa087c-1748-4baf-85b2-52c08bc863c4";

export const MODAL_CLOSE_SEC = 2.5;